/**
 * @desc getInfo
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.logisticsReverseFacadeImpl.getInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/logisticsReverse/getInfo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
